let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g8CRu")).then(() => parcelRequire('4Mu1O'));